import videojs from 'video.js';
import './label-image-component.js';

class LabelImage extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player, options);
		player.on('ready', () => {
			player.addChild('LabelImageComponent', options);
		});
	}
}

videojs.registerPlugin('labelImage', LabelImage);
